import { render, staticRenderFns } from "./Account_history.vue?vue&type=template&id=f6ce18a8&scoped=true&"
import script from "./Account_history.vue?vue&type=script&lang=js&"
export * from "./Account_history.vue?vue&type=script&lang=js&"
import style0 from "./Account_history.vue?vue&type=style&index=0&id=f6ce18a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ce18a8",
  null
  
)

export default component.exports